import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Namastay**
 *
 * @exports bs_404
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_404
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        const isLogged = false;
        return isLogged;
    };
    /**
       * @memberOf module:bs_404
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        // https://www.maison-albar-hotels-le-vendome.com/en/?namastay=true&startDate=2023-11-01&endDate=2023-11-04
        // https://www.paradisecovehotel.com/en?startDate=2024-03-27&endDate=2024-03-30&namastay=true&promoCode=PM2
        // https://hotels-attitude.com/en/friday-attitude?startDate=2025-01-15&endDate=2025-01-16&namastay=true&apiKey=3618306a167b49538dfd7f7d955eadc7k0tug3wl9xx6eag5
        const url = new URL(ctx.baseUrl);
        if (url.host === 'app.namastay.io') {
            ctx.newUrl = '';
            return ctx;
        }
        url.searchParams.set('startDate', '[date_begin]');
        url.searchParams.set('endDate', '[date_end]');
        url.searchParams.set('namastay', 'true');
        if (thn.data.propertyId === 1025159) {
            url.pathname = thn.data.language;
        }
        ctx.newData.dateBegin = ctx.data.dateBegin && ctx.data.dateBegin.replace(/\//g, '-');
        ctx.newData.dateEnd = ctx.data.dateEnd && ctx.data.dateEnd.replace(/\//g, '-');
        ctx.newUrl = url.toString();
        return ctx;
    };
    engine.onStateChange = thn.debounce(function (ctx) {
        thn.languageCheck();
    }, 600);
    /**
       * @memberOf module:bs_404
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot() {
        const container = document.querySelector('#__next, body');
        if (container) {
            let handler = thn.debounce(() => {
                const loader = document.querySelector('.MuiSkeleton-root');
                if (!loader) {
                    thn.pageCheck();
                }
            }, 800);
            thn.observeDom(container, handler, {
                childList: true,
                subtree: true,
                characterData: false,
                attributes: true,
            });
            thn.shutdown(() => {
                handler.cancel();
                thn.stopObserveDom(container, handler);
                handler = null;
            });
        }
        const iframeEl = document.querySelector('iframe[name="Namastay App"]');
        if (iframeEl) {
            const refreshPage = thn.debounce(thn.pageCheck, 500);
            thn.observeDom(iframeEl, refreshPage, {
                attributes: true,
            });
            thn.shutdown(() => {
                refreshPage.cancel();
                thn.stopObserveDom(iframeEl, refreshPage);
            });
        }
    };
    /**
      *
      * @memberOf module:bs_404
      *
      */
    const roomDetailsParseData = (numAdults, numChildren) => {
        const roomsArray = thn.dataLayerHelper.get('ecommerce')?.items || thn.objectGet(window.dataLayer && [...window.dataLayer].filter((search) => !!search?.ecommerce?.items), 'items');
        if (thn.empty(roomsArray)) {
            return {};
        }
        const roomsInfo = roomsArray
            .map((room) => {
            const roomName = room.title;
            const roomType = getRoomType(roomName);
            const ratesInfo = {
                id: '',
                name: room.bestRates?.[0]?.title,
                totalNight: thn.parseNumber(room.bestRates?.[0]?.price || room.price),
                breakfast: !!room.bestRates?.[0]?.title?.match(/breakfast|petit-déjeuner/),
                refundable: !!room.bestRates?.[0]?.cancelPolicy?.match(/Free cancellation|Réservation annulable/),
            };
            const roomData = {
                id: '',
                name: roomName,
                adults: numAdults || 2,
                children: numChildren || 0,
                type: roomType,
                prices: ratesInfo,
            };
            return roomData;
        });
        return roomsInfo;
    };
    /**
       * @memberOf module:bs_404
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        let prices;
        // Dates
        const dateBeginDL = thn.dataLayerHelper.get('ecommerce', { first: false })?.startDate;
        const dateEndDL = thn.dataLayerHelper.get('ecommerce', { first: false })?.endDate;
        const dateBeginRaw = new Date(dateBeginDL);
        const dateEndRaw = new Date(dateEndDL);
        const datesSelectorDom = document.querySelector('div > nav > button')?.textContent?.split(' - ');
        let dateBeginDom = translateDate(datesSelectorDom?.[0], thn.data.language);
        const dateEndDom = translateDate(datesSelectorDom?.[1], thn.data.language);
        const year = dateEndDom?.split('/')?.[0];
        if (!dateBeginDom) {
            dateBeginDom = translateDate(datesSelectorDom?.[0] && year ? `${datesSelectorDom[0]}, ${year}` : null, thn.data.language);
        }
        const dateBegin = (dateBeginRaw && thn.dateToString(dateBeginRaw)) || thn.objectGet(window.dataLayer, 'startDate', { first: false })?.replace(/-/g, '/') || dateBeginDom;
        const dateEnd = (dateEndRaw && thn.dateToString(dateEndRaw)) || thn.objectGet(window.dataLayer, 'endDate', { first: false })?.replace(/-/g, '/') || dateEndDom;
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
        }
        // Guests
        widgetData.adults = thn.parseNumber(thn.dataLayerHelper.get('ecommerce')?.adults) || 2;
        widgetData.children = thn.parseNumber(thn.dataLayerHelper.get('ecommerce')?.children) || 0;
        // Prices & Currency || No Rooms
        const domPricesArray = [...document.querySelectorAll('.text-subtitle3.font-medium.mt-1, p.text-subtitle3 span.font-medium, div > p > span > span.font-medium, div > p > span.text-body-s > span')];
        const domPrices = domPricesArray.map((price) => {
            const cloneElem = price.cloneNode(true);
            const oldElem = cloneElem.querySelector('span.text-hotel-section-subtitle');
            if (oldElem && oldElem?.parentNode) {
                oldElem.parentNode.removeChild(oldElem);
            }
            return thn.parseNumber(cloneElem.textContent);
        })?.filter(Boolean);
        const dataLayerPricesArray = thn.dataLayerHelper.get('ecommerce')?.items || thn.objectGet(window.dataLayer && [...window.dataLayer].filter((search) => !!search?.ecommerce?.items), 'items');
        const dataLayerPrices = !thn.empty(dataLayerPricesArray) && dataLayerPricesArray.map((price) => thn.parseNumber(price.bestRates?.[0]?.price || price.price))?.filter(Boolean);
        const shouldUseDomPrices = [1037181].includes(thn.data.accountUserId);
        if (shouldUseDomPrices) {
            prices = domPrices;
        }
        else {
            prices = dataLayerPrices || domPrices;
        }
        const currency = thn.parseCurrency(document.querySelector('.rounded.uppercase')?.textContent)
            || thn.parseCurrency(document.querySelector('p.text-subtitle3:not(.text-hotel-section-subtitle)')?.textContent)
            || thn.parseCurrency(domPricesArray?.[0]?.textContent)
            || thn.parseCurrency(dataLayerPricesArray?.[0]?.bestRates?.[0]?.currencyCode);
        const noAvailability = !!document.querySelector('p.text-h3')?.textContent?.match(/Désolé|Sorry/);
        if (prices.length && currency) {
            widgetData.price = Math.min(...prices);
            widgetData.currency = currency;
            widgetData.set = true;
            widgetData.roomDetails = roomDetailsParseData(widgetData.adults, widgetData.children);
        }
        else if (noAvailability) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_404
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const dataLayerData = thn.dataLayerHelper.get('ecommerce', { first: false })?.purchase?.actionField || thn.objectGet(window.dataLayer, 'ecommerce', { first: false });
        const bookingId = dataLayerData?.id || dataLayerData?.transaction_id;
        if (!bookingId) {
            widgetData.set = false;
            return widgetData;
        }
        widgetData.bookingId = bookingId;
        widgetData.dateBegin = thn.dateToString(dataLayerData?.startDate);
        widgetData.dateEnd = thn.dateToString(dataLayerData?.endDate);
        widgetData.price = thn.parseNumber(dataLayerData?.revenue || dataLayerData?.value);
        widgetData.currency = dataLayerData?.currency;
        return widgetData;
    };
    return engine;
}

export { factory };
